module.exports = __webpack_public_path__ + "media/images/img/naitei-fe071ecdfc257e3d56b48e9ae0f30511.svg";